import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { handleSnackBar, invokeGetService, invokePostService, setReRender, toggleRightDrawer } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import FormEditor from "../../atoms/jsonFormEditor/FormEditor";
import { getDetailsFromUrl } from '../../../services/blueprint'
import { getViews } from "../../../store/views/selectors";
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { useHistory } from 'react-router-dom';
import { mappingTransactionSchema } from '../../../config/fields';
import { Box, Grid } from '@material-ui/core';
import { findHelperText, injectInlineHelperText } from '../../../utils/DashboardBuilder.js';

const options = {
    form_name_root: "prompt",
    show_errors: "never"
}

export default function ViewPrompt({ id, action, onCompletion, onClose }) {


    const dispatch = useDispatch();
    const history = useHistory();
    const editorWrapper = useRef();

    const selectedView = useSelector(getViews);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const [loading, setLoading] = useState(false)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);
    const [transactionMapping, setTransactionMapping] = useState({});

    useEffect(() => {
        setLoading(true)
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((blueprintConstructs) => {
                let transactionMappingSchema = mappingTransactionSchema(blueprintConstructs?.data?.transactions, false, [...blueprintConstructs?.data?.clusterlets, ...blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1)], blueprintConstructs?.data?.events, blueprintConstructs?.data?.clusterlets.filter(c => c.type === 1), true, false);
                setTransactionMapping(transactionMappingSchema)
                setSchemaValues(mappingSchema());
                setLoading(false)
            })
    }, [])

    let schema = {
        type: 'object',
        required: [],
        options: {
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: {}
    }

    schema = { ...schema, properties: { ...schema.properties, gettertransaction: { ...transactionMapping.transaction, title: "Transaction to fetch policy" }, accepttransaction: { ...transactionMapping.transaction, title: "Accept Transaction" }, denytransaction: { ...transactionMapping.transaction, title: "Deny Transaction" } } }



    const mappingSchema = () => {
        let schemaValues = {};

        schemaValues.gettertransaction = (selectedView.prompt != undefined && selectedView.prompt.gttertransaction !== undefined) ? { [selectedView.prompt.gttertransaction]: selectedView.prompt.gttertransaction } : { 'select': 'select' };
        schemaValues.gettertransaction.instance = (selectedView.prompt != undefined && selectedView.prompt.getterinstance !== undefined) ? selectedView.prompt.getterinstance : '';


        schemaValues.accepttransaction = (selectedView.prompt && selectedView.prompt.buttons && selectedView.prompt.buttons[0] && selectedView.prompt.buttons[0].transaction && selectedView.prompt.buttons[0].title == "Accept") ? { [selectedView.prompt.buttons[0].transaction]: selectedView.prompt.buttons[0].transaction } : { 'select': 'select' };
        schemaValues.accepttransaction.instance = (selectedView.prompt && selectedView.prompt.buttons && selectedView.prompt.buttons[0] && selectedView.prompt.buttons[0].title == "Accept") ? selectedView.prompt.buttons[0].instance : '';

        schemaValues.denytransaction = (selectedView.prompt && selectedView.prompt.buttons && selectedView.prompt.buttons[1] && selectedView.prompt.buttons[1].transaction && selectedView.prompt.buttons[1].title == "Deny") ? { [selectedView.prompt.buttons[1].transaction]: selectedView.prompt.buttons[1].transaction } : { 'select': 'select' };
        schemaValues.denytransaction.instance = (selectedView.prompt && selectedView.prompt.buttons && selectedView.prompt.buttons[1] && selectedView.prompt.buttons[1].title == "Deny") ? selectedView.prompt.buttons[1].instance : '';

        return schemaValues
    }

    const formatSchema = (input) => {
        const result = {};

        const getterTransactionKey = Object.keys(input.gettertransaction).find(key => key !== "instance");
        result.gttertransaction = getterTransactionKey != "select" ? input.gettertransaction[getterTransactionKey] : "";
        result.getterinstance = input.gettertransaction.instance ? input.gettertransaction.instance : "";

        const acceptTransactionKey = Object.keys(input.accepttransaction).find(key => key !== "instance");
        const acceptTransactionValue = input.accepttransaction[acceptTransactionKey];
        const denyTransactionKey = Object.keys(input.denytransaction).find(key => key !== "instance");
        const denyTransactionValue = input.denytransaction[denyTransactionKey];

        result.buttons = [];
        result.buttons.push({
            transaction: acceptTransactionValue != "select" ? acceptTransactionValue : "",
            instance: (acceptTransactionValue != "select" && input.accepttransaction.instance != "") ? input.accepttransaction.instance : "",
            title: "Accept",
            color: "#3fc9d5"
        });

        result.buttons.push({
            transaction: denyTransactionValue != "select" ? denyTransactionValue : "",
            instance: (denyTransactionValue != "select" && input.denytransaction.instance != "") ? input.denytransaction.instance : "",
            title: "Deny",
            color: "#e7505a"
        });

        return result;
    }

    const onSaveSchema = (data) => {
        setIsUpdating(true);
        let formattedSchema = formatSchema(data);
        let updatedView = { ...selectedView, prompt: formattedSchema }

        dispatch(invokePostService('updateView', { view: updatedView }, [selectedView._id])).then(response => {
            setIsUpdating(false);
            if (response.status == true) {
                dispatch(handleSnackBar({ open: true, message: `View updated`, severity: "success" }));
                dispatch(editView(updatedView));
            } else {
                dispatch(editView(selectedView));
                if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    dispatch(handleSnackBar({ open: true, message: response.errors[0].message, severity: 'error' }))
                }
                if (response.code === 255) {
                    const { slug, blueprintId } = getDetailsFromUrl();
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus == true) dispatch(toggleRightDrawer());
                }
            }
        })

    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const customValidation = (data) => {
        let errors = [];
        // if(data?.gettertransaction?.hasOwnProperty('select')){
        //     errors.push({
        //         path: "prompt.gettertransaction",
        //         property: 'format',
        //         message: "Transaction is required",
        //         isSwitcher: true
        //     })
        // }
        // if(data?.accepttransaction?.hasOwnProperty('select')){
        //     errors.push({
        //         path: "prompt.accepttransaction",
        //         property: 'format',
        //         message: "Transaction is required",
        //         isSwitcher: true
        //     })
        // }
        return errors;

    }

    const onChangeJsonEditor = () => {

        const fetchHelperText = findHelperText("view_prompt", "fetch_transaction")
        injectInlineHelperText({
            formId: "view_prompt_form", 
            schemaPath: "prompt.gettertransaction", 
            helperText: fetchHelperText
        })

        const acceptTxnHelperText = findHelperText("view_prompt", "accept_transaction")
        injectInlineHelperText({
            formId: "view_prompt_form", 
            schemaPath: "prompt.accepttransaction", 
            helperText: acceptTxnHelperText
        })

        const denyTxnHelperText = findHelperText("view_prompt", "deny_transaction")
        injectInlineHelperText({
            formId: "view_prompt_form", 
            schemaPath: "prompt.denytransaction", 
            helperText: denyTxnHelperText
        })
    }

    return (

        <>
            {loading &&
                <Grid item xs={12}>
                    <LoaderWithProgress size={20} isContent={true} styleRoot={{ minHeight: '75vh' }} />
                </Grid>
            }
            {!loading && <Box ref={editorWrapper} style={{ width: '100%' }}>
                <FormEditor editorId="view_prompt_form" options={options} schema={schema} onChangeJsonEditor={onChangeJsonEditor} onSave={onSaveSchema} onClose={onClose} schemaValues={schemaValues} validation={validation} key={id} action={"edit"} customValidation={customValidation} isUpdating={isUpdating} />
            </Box>}
        </>



    )



}